import React, { Component } from 'react'
import { GENRE } from './../constants/Genre'

export default class Genre extends Component {

    render() {
        var chosenGenre = this.props.chosenGenre;
        var black = { color: 'black' }
        var grey = { color: 'darkgrey' }
        var lightgrey = { color: 'lightgrey' }
        var white = { color: 'white' }
        var GenreCol = (this.props.modal === true) ? "ModalGenre" : "Genre-column"      
        
        return (
            <div className={GenreCol}>
                                

                <div className="VL"></div>


                <br></br>
                
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>

                    {
                        GENRE.map((genre, key) => {
                            if (this.props.modal != true) {
                                var highlight = (chosenGenre === genre.id) ? black : grey
                            }
                            else {
                                var highlight = (chosenGenre === genre.id) ? white : grey
                            }
                          
                            
                            return (
                                
                                <a key={key} href={genre.link}
                             
                                    onClick={() => {
                                        this.props.changeGenre(genre.id, genre.name)
                                        if (this.props.modal) this.props.handleClose();
                                    }}
                                    className="Tabs"
                                    style={highlight}>
                                    {genre.name}
                                </a>
                            )
                        })
                    }
              
                    
                </div>
                {this.props.children}
            </div>

        )
    }
}

//            <div style={{ position: 'absolute',display: '-moz-box',display: 'flex', flexDirection: 'column',alignItems:'center' }}>



// WEBPACK FOOTER //
// ./src/components/Genre.js